<script>
export default {
    data() {
        return {
            phoneNumber: "",
            addButtonDisabled: true,
        }
    },
    methods: {
        checkAddButtonDisabledStatus(event) {
            this.phoneNumber = event.target.value

            if (this.phoneNumber.trim()) {
                try {
                    const convertedPhoneNumber = Number(this.phoneNumber)

                    if (convertedPhoneNumber) {
                        this.addButtonDisabled = false
                    }
                } catch (e) {
                    this.addButtonDisabled = true
                }
            } else {
                this.addButtonDisabled = true
            }
        },
    },
}
</script>

<template>
    <div
        class="d-flex justify-content-center align-items-center w-100 add-new-contact-dialog"
    >
        <div class="bg-white rounded-lg p-3 w-50 shadow">
            <h3>Add Contact</h3>
            <form>
                <div class="input-group mt-2 no-shadow">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-primary text-white">
                            +65
                        </span>
                    </div>
                    <input
                        :value="phoneNumber"
                        type="text"
                        class="form-control"
                        placeholder="Phone Number"
                        @input="checkAddButtonDisabledStatus"
                    />
                </div>
                <div class="d-flex justify-content-between w-100 mt-4">
                    <button
                        @click="$emit('on-cancel-click')"
                        type="button"
                        class="btn btn-danger"
                    >
                        Cancel
                    </button>
                    <button
                        @click.prevent="
                            $emit('on-add-contact-click', [phoneNumber])
                        "
                        type="submit"
                        class="btn btn-primary"
                        :disabled="addButtonDisabled"
                    >
                        Add
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<style>
.add-new-contact-dialog {
    position: absolute;
    z-index: 1000;
    height: 85%;
}
</style>
